import { Box, Typography, Grid, TextField, IconButton, Button, CircularProgress } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useUtiles } from '../../../../shared/context/utilesContext'
import { useInsumo } from '../../../../shared/context/insumoContext'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import isumecube from '../../../../assets/isumecube.png'
import { useTaskContext } from '../../../../shared/context/taskContext'
export default function SelectResourceComponent() {
    const {restorePreviousComponent, locationString} = useUtiles()
    const {getInsumoByCode, insumosByCode, loadingInsumoByCode} = useInsumo()
    const { setResourceSelected, setIsSelectResource} = useTaskContext()
    const {control} = useForm()
    

    useEffect(() => {
        getInsumoByCode()
    }, [])


    

    const handleSelectInsumo = (insumo) => {
        setResourceSelected({...insumo, quantity: 1, confirmed: true})
        setIsSelectResource(true)
        restorePreviousComponent()
    }
    return (
        <Box sx={{ padding: { xs: "10px", md: "20px" } }}>
            <Grid container spacing={2}>
                <Grid item size={{ xs: 12 }} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TextField
                        label="Buscar Insumo por código o nombre"
                        name="code"
                        fullWidth
                        onChange={(e) => getInsumoByCode(e.target.value, true)}
                    />
                    <IconButton onClick={() => getInsumoByCode(null, true)}>
                        <RefreshIcon  />
                    </IconButton>
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <Button onClick={() => restorePreviousComponent()} variant="contained" color="primary" startIcon={<ArrowBackIcon />}>Regresar</Button>
                </Grid>

                {loadingInsumoByCode ? (
                    <CircularProgress />
                ) : (
                    <Grid item size={{ xs: 12}}>
                        {insumosByCode && insumosByCode.length > 0 ? (
                            <Box sx={{ mt: 1 }}>
                                <Typography variant="h6" gutterBottom sx={{fontSize: '1rem'}}>
                                    Insumos Disponibles
                                </Typography>
                                {insumosByCode.map((insumo) => (
                                    <Box 
                                        key={insumo.id}
                                        onClick={() => handleSelectInsumo(insumo)}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            p: 2,
                                            mb: 2,
                                            borderRadius: 2,
                                            boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
                                            bgcolor: 'background.paper',
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                boxShadow: '0 6px 15px rgba(0,0,0,0.12)',
                                                transform: 'translateY(-2px)',
                                                cursor: 'pointer'
                                            }
                                        }}
                                    >
                                        <Box sx={{ 
                                            display: 'flex', 
                                            justifyContent: 'center', 
                                            alignItems: 'center',
                                            bgcolor: 'primary.main',
                                            borderRadius: '12px',
                                            width: 60,
                                            height: 60,
                                            mr: 2,
                                            overflow: 'hidden'
                                        }}>
                                            <img 
                                                src={isumecube} 
                                                alt="isumecube" 
                                                style={{ 
                                                    width: '80%', 
                                                    height: 'auto', 
                                                    objectFit: 'contain' 
                                                }} 
                                            />
                                        </Box>
                                        <Grid container spacing={1}>
                                            <Grid item  size={{ xs: 12}}>
                                                <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 0.5 }}>
                                                    {insumo.name}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {insumo.description || 'Sin descripción'}
                                                </Typography>
                                            </Grid>
                                            <Grid item size={{ xs: 12}}>
                                                <Box sx={{ 
                                                    display: 'flex', 
                                                    flexDirection: 'column', 
                                                    gap: 0.5,
                                                    '& .MuiTypography-root': {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 0.5
                                                    }
                                                }}>
                                                    <Typography variant="body2">
                                                        <strong>Tipo:</strong> {insumo.type_insumo?.name || 'N/A'}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        <strong>Cantidad:</strong> {insumo.amount || 0} {insumo.unit || 'unidades'}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        <strong>Ubicación:</strong> {locationString(insumo.location) || 'No especificada'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))}
                            </Box>
                        ) : (
                            <Typography variant="body1" sx={{ mt: 2, textAlign: 'center' }}>
                                No se encontraron insumos. Intente con otra búsqueda.
                            </Typography>
                        )}
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}